import React, { useRef } from "react";

import { Stack, Typography, TextField } from "@mui/material";
import { MdOutlineAttachFile } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { HiArrowDownTray } from "react-icons/hi2";
import { useMutation } from "@tanstack/react-query";
import { getSingedUrlSurveyDoc } from "actions/survey/surveyAction";


function DocumentUpload({
  value,
  error,
  name,
  handleChange,
  viewOnly = false,
  accept = ".pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .jpeg, .png, .gif",
  isFrom = '',
  question
}) {
  const fileInputRef = useRef(null); // Create a ref to the file input
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0]; // Get the first selected file

    if (isFrom === 'surveyTask') {

      handleChange(question, selectedFile)

    } else {
      handleChange({
        target: {
          name,
          value: selectedFile,
        },
      });
    }


  };

  const handleTextFieldClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the file input dialog
    }
  };

  const { mutateAsync } = useMutation({
    mutationFn: getSingedUrlSurveyDoc,
    onSuccess: (data) => {
    },
    onError: (error) => {
      // Handle error
      console.error("Create failed:", error);
    },
    staleTime: Infinity,
    cacheTime: 0,
  });

  const handleDownload = async (
    key,
    file_name
  ) => {
    // const updateDataStructure = transformData(data);

    let response = await mutateAsync({
      key,
    });
    if(response?.status){
      downloadFile(response?.url, file_name)
    }
    return response;
  };

  const downloadFile = (fileUrl, fileName) => {

    const link = document.createElement("a"); // Create a temporary anchor element
    link.href = fileUrl; // Set the href to the file URL
    link.download = fileName; // Set the desired file name for download
    // link.target = "_blank"
    document.body.appendChild(link); // Append the link to the body (not displayed)
    link.click(); // Programmatically click the link to trigger the download
    document.body.removeChild(link); // Clean up: remove the link
  };


  return (
    <>
      {viewOnly && value && Object.keys(value).length > 0 && (
        <Stack
          sx={{
            border: "1px solid  #E9E9E9",
            borderRadius: "8px",
            // width: "45%",
          }}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"flex-start"}
          //   gap={5}
          padding={1}
          mb={1}
        >
          <MdOutlineAttachFile
            size={"1.5em"}
            style={{ color: "#3374B9", marginRight: "10px" }}
          />
          <Typography variant="body1">{value?.name || value}</Typography>
          <HiArrowDownTray
            size={"1.5em"}
            style={{ color: "#3374B9", marginLeft: "auto", cursor: "pointer" }}
            onClick={() => isFrom === "surveyResponse" ? handleDownload(value?.key, value?.name) : downloadFile(value?.url || value?.key, value?.name)}
          />
        </Stack>
      )}
      {!viewOnly && (
        <Stack
          sx={(theme) => ({
            backgroundColor: !value && theme.palette.primary.lighter,

            color: !value && theme.palette.primary.dark,

            border: "1px solid  #E9E9E9",
            borderRadius: "8px",
            width: "45%",
            cursor: "pointer",
          })}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"flex-start"}
          //   gap={5}
          padding={1}
          mb={1}
        >
          <MdOutlineAttachFile
            size={"1.5em"}
            style={{ color: "#3374B9", marginRight: "10px" }}
          />
          <TextField
            variant="standard"
            placeholder="Add Attachment"
            value={value ? value.name : ""} // Display file name if selected
            onClick={handleTextFieldClick} // Trigger file input on click
            error={Boolean(error)}
            helperText={error}
            size="small"
            readOnly // Prevent user from typing in the TextField
            fullWidth
            sx={{
              cursor: "pointer", // Ensure the cursor style applies

              "& .MuiInputBase-input": {
                cursor: "pointer", // Targets the input field specifically
              },
            }} // This ensures the container also uses the pointer cursor
          />
          <input
            type="file"
            accept={accept} // Accept specific file types
            onChange={handleFileChange} // Handle file selection
            style={{ display: "none", cursor: "pointer" }} // Hide the file input
            ref={fileInputRef} // Assign the ref to the input
          />
          {value && (
            <IoMdClose
              onClick={(e) => {
                if (isFrom === 'surveyTask') {

                  handleChange(question, null)

                } else {
                  handleChange({
                    target: {
                      name,
                      value: "",
                    },
                  })

                }
              }
              }
              size={"1.5em"}
              style={{
                cursor: "pointer",
                color: "#3374B9",
                marginLeft: "auto",
              }}
            />
          )}
        </Stack>
      )}
    </>
  );
}

export default DocumentUpload;
